export const ALLCOUNTRY = 'All Countries';
export const allowRoles: string[] = ['CPak_Affiliate', 'CPak_Contract_Admin'];
export const ACCOUNT = '/accounts';
export const CATALOG = '/catalog';
export const CURRENTROUT = 'currentRoute';
export const COUNTRYARRAYLEN = 1;
export const GUIDELINESPATH = '/guidelines';
